import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  VerticalListSortingStrategy,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CollapseContainer, PreviewDataContainer, BoxDataWrapper } from '../../pages/PmsMainPage/PmsMainPage.styled';
import {Slideout, Collapse, Button, Typography} from '@ann/web-components';
import { DragIndicator } from '@mui/icons-material';

// Sortable Collapse Item Component
const SortableCollapseItem = ({ id, title, children, defaultOpen = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    marginBottom: '8px',
  };

  return (  
    <div ref={setNodeRef} style={style}>
      <Collapse
        title={
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <div
              {...attributes}
              {...listeners}
              style={{
                cursor: 'grab',
                padding: '4px',
                marginRight: '8px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
            >
              <DragIndicator 
                style={{ 
                  fontSize: '16px',
                  color: '#666',
                }} 
              />
            </div>
            <span style={{ flex: 1 }}>{title}</span>
          </div>
        }
        defaultOpen={defaultOpen}
        onClose={() => {}}
      >
        {children}
      </Collapse>
    </div>
  );
};

const PreviewSlideOut = ({ 
  open, 
  onClose, 
  selectedPrompt,
  onDuplicateClick 
}) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([
    { 
      id: '1', 
      title: 'General Information',
      defaultOpen: true,
      content: 'general_info' 
    },
    //{ id: '2', title: 'Agents who used this Prompt', content: 'agents' },
    //{ id: '3', title: 'Prompts', content: 'prompts' },
  ]);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = items.findIndex((item) => item.id === active.id);
        const newIndex = items.findIndex((item) => item.id === over.id);

        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const handleEditClick = () => {
    if (selectedPrompt && selectedPrompt.uuid) {
      navigate(`/v2/pms/config/${selectedPrompt.uuid}`);
    }
  };

  const handleDuplicateClick = () => {
    if (selectedPrompt && onDuplicateClick) {
      onDuplicateClick(selectedPrompt);
    }
  };

  // Función para renderizar el contenido según el tipo de sección
  const renderContent = (contentType) => {
    if (!selectedPrompt) return null;
    
    switch (contentType) {
      case 'general_info':
        return (
          <PreviewDataContainer>
            <BoxDataWrapper>
              <Typography category="subtitle" size="medium" weight="bold">
                Name
              </Typography>
              <Typography  category="body" size="medium" weight="regular">
                {selectedPrompt?.name || 'No name available'}
              </Typography>
            </BoxDataWrapper>

            <BoxDataWrapper>
              <Typography category="subtitle" size="medium" weight="bold">
                Description
              </Typography>
              <Typography  category="body" size="medium" weight="regular">
                {selectedPrompt?.description || 'No description available'}
              </Typography>
            </BoxDataWrapper>
            <BoxDataWrapper>
              <Typography category="subtitle" size="medium" weight="bold">
                LLM Model
              </Typography>
              <Typography  category="body" size="medium" weight="regular">
                {selectedPrompt?.llmModel || 'No model specified'}
              </Typography>
            </BoxDataWrapper>
          </PreviewDataContainer>
        );
      /*
      case 'agents':
        return (
          <p>Agents who used this Prompt</p>
        );
      case 'prompts':
        return (
          <p>Prompts</p>
        );
      */
      default:
        return <div style={{ padding: '16px' }}>Content not available</div>;
    }
  };

  if (!selectedPrompt) return null;
  
  return (
    <Slideout
      title="Slide Out Panel"
      open={open}
      onClose={onClose}
    >
      <Slideout.Title size="large">Slide Out Panel</Slideout.Title>
      <Slideout.Content>
        <CollapseContainer>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={items.map(item => item.id)}
              strategy={verticalListSortingStrategy}
            >
              {items.map((item) => (
                <SortableCollapseItem
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  defaultOpen={item.defaultOpen}
                >
                  {renderContent(item.content)}
                </SortableCollapseItem>
              ))}
            </SortableContext>
          </DndContext>
        </CollapseContainer>
      </Slideout.Content>
      <Slideout.Actions>
        <Button 
          label={'Duplicate'} 
          type='secondary' 
          size={'medium'} 
          disabled={!selectedPrompt || !selectedPrompt.uuid}
          onClick={handleDuplicateClick}
        />
        <Button 
          label={'Edit'} 
          type='primary' 
          size={'medium'} 
          disabled={!selectedPrompt || !selectedPrompt.uuid}
          onClick={handleEditClick}
        />
      </Slideout.Actions>
    </Slideout>
  );
};

export default PreviewSlideOut; 